import { render, staticRenderFns } from "./IndexSearchSetup.vue?vue&type=template&id=00df7268&scoped=true&"
import script from "./IndexSearchSetup.vue?vue&type=script&lang=js&"
export * from "./IndexSearchSetup.vue?vue&type=script&lang=js&"
import style0 from "./IndexSearchSetup.vue?vue&type=style&index=0&id=00df7268&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00df7268",
  null
  
)

export default component.exports